import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import { DesignLayout } from '@common/DesignLayout';
import { RoutePath } from '@components/AppRouter/constants';
import { useCheckFromDictionaryCard } from '@src/utils/hooks/useCheckFromDictionaryCard';
import { controlGroupsStore } from '@stores/dictionaryStores/controlGroupsStore/controlGroupsStore';

import { useAuditView } from '../../hooks/useAuditView';
import { Table } from './Table';

export const ControlGroups = observer(() => {
  const { fetch, clear } = controlGroupsStore;

  const isBack = useCheckFromDictionaryCard(RoutePath.DICTIONARY_CONTROL_GROUPS);

  useAuditView('Группы контролей');

  useEffect(() => {
    void (async () => {
      await fetch();
    })();
  }, [fetch]);

  useEffect(() => {
    if (!isBack) clear();
  }, [clear, isBack]);

  return (
    <DesignLayout scrollEnable>
      <Table />
    </DesignLayout>
  );
});
